"use client";

import { useEffect } from "react";
import { ServiceUnavailable } from "@/components/ServiceUnavailable";

/**
 * Root error UI — replaces the default Next.js
 * "Application error: a client-side exception has occurred" page.
 * Must render its own <html>/<body> (does not use root layout).
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error]", error);
  }, [error]);

  return (
    <html lang="en">
      <body className="min-h-screen flex items-center justify-center bg-neutral-50 p-4 antialiased">
        <ServiceUnavailable
          title="Something went wrong"
          description="We couldn’t load this page. This can happen when our servers are briefly unavailable. Please try again."
          onRetry={reset}
        />
      </body>
    </html>
  );
}
